<mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
  <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #1e293b;">
    <mat-card-title>
      <div class="w-100 d-flex" style="background: #0f172a;">
        <span style="display: flex; align-items: center; margin-left: 15px; color: #27f349; font-size: 14px;">Résultat inscription</span>
        <button class="m-l-auto" mat-icon-button (click)="matDialogRef.close();">
          <i-tabler name="x" class="icon-18" style="color: #27f349;"></i-tabler>
        </button>
      </div>
    </mat-card-title>
    <mat-card-subtitle style="color: black;background: white;" class="p-t-16 p-b-16">
      <div class="d-flex">
        <div class="d-flex flex">
          <div style="border-right: 2px solid black; margin-right: 15px;">
            <button mat-icon-button>
              <i-tabler name="check" class="icon-24 d-flex" style="color: #41bf32; align-items: center;"></i-tabler>
            </button>
          </div>
          <div class="d-grid">
            <span class="f-w-700"> Bienvenue à vous! </span>
            <span style="padding-top: 8px; font-size: 13px; color: #9b9b9f; font-weight: 600;">Programme fidélité</span>
          </div>
        </div>
        <div class="m-l-auto">
        </div>
      </div>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content style="flex: 1;padding: 0;">
    <div class="text-center">
      <i-tabler name="credit-card" class="icon-256" style="color: #27f349;width: 256px;height: 256px;"></i-tabler>
    </div>
    <div class="text-center">
      <p>Numéro client : <span>{{ inscriptionResult.NUMERO_CLIENT }}</span></p>
      <p>
        Bonjour et bienvenue dans notre programme de fidélité ! Nous sommes enchantés de vous compter parmi nos clients privilégiés. Profitez d'avantages exclusifs et de récompenses irrésistibles. 
      </p>
    </div>
  </mat-card-content>
  <mat-card-actions class="d-block m-0 p-0" style="background-color: #ffffff; border-top: 3px solid #1e293b;">
    <div class="d-flex w-100" style="padding-top: 6px;">
      <button mat-stroked-button style="color: #707387; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1;" (click)="matDialogRef.close();"> TERMINER </button>
    </div>
  </mat-card-actions>
</mat-card>